import { render, staticRenderFns } from "./notification-row.vue?vue&type=template&id=15234dc4&scoped=true&"
import script from "./notification-row.vue?vue&type=script&lang=js&"
export * from "./notification-row.vue?vue&type=script&lang=js&"
import style0 from "./notification-row.vue?vue&type=style&index=0&id=15234dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15234dc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15234dc4')) {
      api.createRecord('15234dc4', component.options)
    } else {
      api.reload('15234dc4', component.options)
    }
    module.hot.accept("./notification-row.vue?vue&type=template&id=15234dc4&scoped=true&", function () {
      api.rerender('15234dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/elements/notification-row.vue"
export default component.exports